import Spouse from 'src/value-objects/Spouse';
import { Moment } from 'moment';
import * as moment from 'moment';
import InvestorType from 'src/entities/InvestorType';
import { isNullOrUndefined } from 'util';

export interface JuridicalPersonProperties {
  id: number;
  name: string;
  displayName?: string;
  surname: string;
  nationality?: string;
  idNumber?: string;
  idExpirationDate?: Moment;
  idFront?: string;
  idBack?: string;
  birthDate?: Moment;
  phoneNumber?: string;
  notificationEmail?: string;
  email?: string;
  address?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  country?: string;
  maritalStatus?: string;
  maritalEconomicStatus?: string;
  maritalPropertyRegime?: string;
  occupationType?: string;
  occupation?: string;
  company?: string;
  spouse?: Spouse;
  profilePicture?: string;
  facebookProfile?: string;
  twitterProfile?: string;
  linkedinProfile?: string;
  enterpriseName: string;
  officeAddress?: string;
  establishmentDate?: Moment;
  notaryName?: string;
  notaryAddress?: string;
  protocolNumber?: string;
  cifNumber?: string;
  provinceCommercialRegister?: string;
  corporateEmail?: string;
  volumeNumber?: string;
  pageNumber?: string;
  sheetNumber?: string;
  companyProxy?: string;
  companyProxyIncluded?: boolean;
  establishmentRepresentativeDate?: Moment;
  provinceDeed?: string;
  notaryProxyName?: string;
  protocolProxyNumber?: string;
  cifDocument?: string;
  cifDocumentImage?: string;
  deedCompany?: string;
  deedCompanyImage?: string;
  companyStatutes?: string;
  companyStatutesImage?: string;
  realOwnership?: string;
  realOwnershipImage?: string;
  idRepresentatives?: string;
  idRepresentativesImage?: string;
  notarialDeed?: string;
  notarialDeedImage?: string;
  userId: number;
  personType: string;
  investorType: InvestorType;
  isPublicProfile?: boolean;
  percentCompleted?: number;
}

export default class JuridicalPerson {
  id: number;
  name: string;
  displayName: string;
  surname: string;
  nationality?: string;
  idNumber?: string;
  idExpirationDate?: Moment;
  idFront?: string;
  idBack?: string;
  birthDate?: Moment;
  phoneNumber?: string;
  notificationEmail?: string;
  email?: string;
  address?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  country?: string;
  maritalStatus?: string;
  maritalEconomicStatus?: string;
  maritalPropertyRegime?: string;
  occupationType?: string;
  occupation?: string;
  company?: string;
  spouse?: Spouse;
  profilePicture?: string;
  facebookProfile?: string;
  twitterProfile?: string;
  linkedinProfile?: string;
  enterpriseName: string;
  officeAddress?: string;
  establishmentDate?: Moment;
  notaryName?: string;
  notaryAddress?: string;
  protocolNumber?: string;
  cifNumber?: string;
  provinceCommercialRegister?: string;
  corporateEmail?: string;
  volumeNumber?: string;
  pageNumber?: string;
  sheetNumber?: string;
  companyProxy?: string;
  companyProxyIncluded?: boolean;
  establishmentRepresentativeDate?: Moment;
  provinceDeed?: string;
  notaryProxyName?: string;
  protocolProxyNumber?: string;
  cifDocument?: string;
  cifDocumentImage?: string;
  deedCompany?: string;
  deedCompanyImage?: string;
  companyStatutes?: string;
  companyStatutesImage?: string;
  realOwnership?: string;
  realOwnershipImage?: string;
  idRepresentatives?: string;
  idRepresentativesImage?: string;
  notarialDeed?: string;
  notarialDeedImage?: string;
  userId: number;
  personType: string;
  investorType: InvestorType;
  isPublicProfile: boolean;
  percentCompleted?: number;

  constructor(entity: JuridicalPersonProperties) {
    this.id = entity.id;
    this.name = entity.name;
    this.displayName = entity.displayName || '';
    this.surname = entity.surname;
    this.nationality = entity.nationality || undefined;
    this.idNumber = entity.idNumber || undefined;
    this.idExpirationDate = entity.idExpirationDate ? moment.utc(entity.idExpirationDate) : undefined;
    this.idFront = entity.idFront || undefined;
    this.idBack = entity.idBack || undefined;
    this.birthDate = entity.birthDate ? moment.utc(entity.birthDate) : undefined;
    this.phoneNumber = entity.phoneNumber || undefined;
    this.notificationEmail = entity.notificationEmail || undefined;
    this.email = entity.email || undefined;
    this.address = entity.address || undefined;
    this.houseNumber = entity.houseNumber || undefined;
    this.zipCode = entity.zipCode || undefined;
    this.city = entity.city || undefined;
    this.province = entity.province || undefined;
    this.country = entity.country || undefined;
    this.maritalStatus = entity.maritalStatus || undefined;
    this.maritalEconomicStatus = entity.maritalEconomicStatus || undefined;
    this.maritalPropertyRegime = entity.maritalPropertyRegime || undefined;
    this.occupationType = entity.occupationType || undefined;
    this.occupation = entity.occupation || undefined;
    this.company = entity.company || undefined;
    this.spouse = entity.spouse ? new Spouse(entity.spouse) : undefined;
    this.profilePicture = entity.profilePicture || undefined;
    this.facebookProfile = entity.facebookProfile || undefined;
    this.twitterProfile = entity.twitterProfile || undefined;
    this.linkedinProfile = entity.linkedinProfile || undefined;
    this.enterpriseName = entity.enterpriseName;
    this.officeAddress = entity.officeAddress || undefined;
    this.establishmentDate = entity.establishmentDate ? moment.utc(entity.establishmentDate) : undefined;
    this.notaryName = entity.notaryName || undefined;
    this.notaryAddress = entity.notaryAddress || undefined;
    this.protocolNumber = entity.protocolNumber || undefined;
    this.cifNumber = entity.cifNumber || undefined;
    this.provinceCommercialRegister = entity.provinceCommercialRegister || undefined;
    this.corporateEmail = entity.corporateEmail || undefined;
    this.volumeNumber = entity.volumeNumber || undefined;
    this.pageNumber = entity.pageNumber || undefined;
    this.sheetNumber = entity.sheetNumber || undefined;
    this.companyProxy = entity.companyProxy || undefined;
    this.companyProxyIncluded = entity.companyProxyIncluded || undefined;
    this.establishmentRepresentativeDate = entity.establishmentRepresentativeDate ?
      moment.utc(entity.establishmentRepresentativeDate) : undefined;
    this.provinceDeed = entity.provinceDeed || undefined;
    this.notaryProxyName = entity.notaryProxyName || undefined;
    this.protocolProxyNumber = entity.protocolProxyNumber || undefined;
    this.cifDocument = entity.cifDocument || undefined;
    this.cifDocumentImage = entity.cifDocumentImage || undefined;
    this.deedCompany = entity.deedCompany || undefined;
    this.deedCompanyImage = entity.deedCompanyImage || undefined;
    this.companyStatutes = entity.companyStatutes || undefined;
    this.companyStatutesImage = entity.companyStatutesImage || undefined;
    this.realOwnership = entity.realOwnership || undefined;
    this.realOwnershipImage = entity.realOwnershipImage || undefined;
    this.idRepresentatives = entity.idRepresentatives || undefined;
    this.idRepresentativesImage = entity.idRepresentativesImage || undefined;
    this.notarialDeed = entity.notarialDeed || undefined;
    this.notarialDeedImage = entity.notarialDeedImage || undefined;
    this.userId = entity.userId;
    this.personType = entity.personType;
    this.investorType = new InvestorType(entity.investorType);
    this.isPublicProfile = entity.isPublicProfile || false;
    this.percentCompleted = entity.percentCompleted || 0;
  }

  public getName(): string {
    return this.enterpriseName;
  }

  public isProfileCompleted(): boolean {
    let notNull = !isNullOrUndefined(this.name) && !isNullOrUndefined(this.surname) &&
      !isNullOrUndefined(this.nationality) && !isNullOrUndefined(this.email) &&
      !isNullOrUndefined(this.enterpriseName) && !isNullOrUndefined(this.corporateEmail) &&
      !isNullOrUndefined(this.birthDate) && !isNullOrUndefined(this.address) && !isNullOrUndefined(this.zipCode) &&
      !isNullOrUndefined(this.city) && !isNullOrUndefined(this.province) && !isNullOrUndefined(this.country) &&
      !isNullOrUndefined(this.phoneNumber);

    return notNull;
  }

}



// WEBPACK FOOTER //
// ./src/entities/JuridicalPerson.tsx